/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * ows-abacus-state
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from "zod";

/**
 * Get an Abacus state by ID
 */
export const getAbacusStatePathAbacusStateIdMin = 0;

export const getAbacusStateParams = zod.object({
  abacus_state_id: zod
    .number()
    .min(getAbacusStatePathAbacusStateIdMin)
    .describe("The ID of the Abacus state"),
});

export const getAbacusStateHeader = zod.object({
  "Correlation-Id": zod.string().optional().describe("Correlation ID"),
});

export const getAbacusStateResponseAbacusStateIdMin = 0;
export const getAbacusStateResponseParentTableIdMin = 0;

export const getAbacusStateResponse = zod.object({
  abacus_state_id: zod
    .number()
    .min(getAbacusStateResponseAbacusStateIdMin)
    .optional()
    .describe("Abacus state ID"),
  action_name: zod
    .enum([
      "payment_eligibility",
      "tax_eligibility",
      "approve_sales_files",
      "close_period",
      "deliver_sales_files",
      "mark_runs_as_complete",
      "prep_mechanical_deductions",
      "commit_royalties",
      "legacy_sync",
      "sap_sync",
      "banking_details_review",
      "payment_eligibility",
      "banking_eligibility",
      "generate_export",
      "generate_payments",
      "send_payments",
      "upload_approval",
      "send_payments",
      "calculate_payments",
      "generate_export",
      "generate_payments",
      "send_payments",
      "upload_approval",
      "send_payment",
      "approve_sales",
      "get_eligible_sales",
      "release_reserves",
      "statement_period_close",
      "upload_exchange_rates",
      "apply_file",
      "approve_file",
      "import_file",
      "upload_file",
      "close_balance",
      "collaborators_auto_report_run",
      "funds_confirmed",
      "salesforce_id_confirmed",
      "salesforce_id_linked",
      "send_payments",
    ])
    .optional()
    .describe("Abacus state action name"),
  action_status: zod
    .enum(["approved", "complete", "error", "init", "rejected", "running"])
    .optional()
    .describe("Abacus state action status"),
  created_at: zod
    .string()
    .datetime({})
    .optional()
    .describe("A datetime string formatted as YYYY-MM-DDTHH:MM:SS.fz"),
  created_by: zod.string().optional(),
  last_modified: zod
    .string()
    .datetime({})
    .optional()
    .describe("A datetime string formatted as YYYY-MM-DDTHH:MM:SS.fz"),
  last_modified_by: zod.string().optional(),
  message: zod
    .string()
    .nullish()
    .describe("A description or message about the state"),
  parent_table_id: zod
    .number()
    .min(getAbacusStateResponseParentTableIdMin)
    .optional()
    .describe("ID in the parent table"),
  parent_table_name: zod
    .enum([
      "account_payee",
      "accounting_period",
      "accounting_run",
      "contract",
      "payee",
      "payment_group_payment",
      "payment_group_payment_account",
      "payment_group_payment_batch",
      "sales_file",
      "statement_period",
      "statement_period_adjustment_file",
      "statement_period_payment_entity",
      "worksheet_payment_contract_advance",
    ])
    .optional()
    .describe("Name of the parent table"),
});

/**
 * Update an Abacus state
 */
export const updateAbacusStatePathAbacusStateIdMin = 0;

export const updateAbacusStateParams = zod.object({
  abacus_state_id: zod
    .number()
    .min(updateAbacusStatePathAbacusStateIdMin)
    .describe("The ID of the Abacus state"),
});

export const updateAbacusStateHeader = zod.object({
  "Correlation-Id": zod.string().optional().describe("Correlation ID"),
});

export const updateAbacusStateBody = zod.object({
  action_status: zod
    .enum(["approved", "complete", "error", "init", "rejected", "running"])
    .describe("Abacus state action status"),
  message: zod
    .string()
    .nullish()
    .describe("A description or message about the state"),
});

export const updateAbacusStateResponseAbacusStateIdMin = 0;
export const updateAbacusStateResponseParentTableIdMin = 0;

export const updateAbacusStateResponse = zod.object({
  abacus_state_id: zod
    .number()
    .min(updateAbacusStateResponseAbacusStateIdMin)
    .optional()
    .describe("Abacus state ID"),
  action_name: zod
    .enum([
      "payment_eligibility",
      "tax_eligibility",
      "approve_sales_files",
      "close_period",
      "deliver_sales_files",
      "mark_runs_as_complete",
      "prep_mechanical_deductions",
      "commit_royalties",
      "legacy_sync",
      "sap_sync",
      "banking_details_review",
      "payment_eligibility",
      "banking_eligibility",
      "generate_export",
      "generate_payments",
      "send_payments",
      "upload_approval",
      "send_payments",
      "calculate_payments",
      "generate_export",
      "generate_payments",
      "send_payments",
      "upload_approval",
      "send_payment",
      "approve_sales",
      "get_eligible_sales",
      "release_reserves",
      "statement_period_close",
      "upload_exchange_rates",
      "apply_file",
      "approve_file",
      "import_file",
      "upload_file",
      "close_balance",
      "collaborators_auto_report_run",
      "funds_confirmed",
      "salesforce_id_confirmed",
      "salesforce_id_linked",
      "send_payments",
    ])
    .optional()
    .describe("Abacus state action name"),
  action_status: zod
    .enum(["approved", "complete", "error", "init", "rejected", "running"])
    .optional()
    .describe("Abacus state action status"),
  created_at: zod
    .string()
    .datetime({})
    .optional()
    .describe("A datetime string formatted as YYYY-MM-DDTHH:MM:SS.fz"),
  created_by: zod.string().optional(),
  last_modified: zod
    .string()
    .datetime({})
    .optional()
    .describe("A datetime string formatted as YYYY-MM-DDTHH:MM:SS.fz"),
  last_modified_by: zod.string().optional(),
  message: zod
    .string()
    .nullish()
    .describe("A description or message about the state"),
  parent_table_id: zod
    .number()
    .min(updateAbacusStateResponseParentTableIdMin)
    .optional()
    .describe("ID in the parent table"),
  parent_table_name: zod
    .enum([
      "account_payee",
      "accounting_period",
      "accounting_run",
      "contract",
      "payee",
      "payment_group_payment",
      "payment_group_payment_account",
      "payment_group_payment_batch",
      "sales_file",
      "statement_period",
      "statement_period_adjustment_file",
      "statement_period_payment_entity",
      "worksheet_payment_contract_advance",
    ])
    .optional()
    .describe("Name of the parent table"),
});

/**
 * Get all state actions for a specified parent_table_name and parent_table_id
 */
export const getAbacusStatesByParentTablePathParentTableIdMin = 0;

export const getAbacusStatesByParentTableParams = zod.object({
  parent_table_id: zod
    .number()
    .min(getAbacusStatesByParentTablePathParentTableIdMin)
    .describe("The ID of the record in the parent table"),
  parent_table_name: zod
    .enum([
      "account_payee",
      "accounting_period",
      "accounting_run",
      "contract",
      "payee",
      "payment_group_payment",
      "payment_group_payment_account",
      "payment_group_payment_batch",
      "sales_file",
      "statement_period",
      "statement_period_adjustment_file",
      "statement_period_payment_entity",
      "worksheet_payment_contract_advance",
    ])
    .describe("Name of the royalty_accounting table"),
});

export const getAbacusStatesByParentTableHeader = zod.object({
  "Correlation-Id": zod.string().optional().describe("Correlation ID"),
});

export const getAbacusStatesByParentTableResponseAbacusStateIdMin = 0;
export const getAbacusStatesByParentTableResponseParentTableIdMin = 0;

export const getAbacusStatesByParentTableResponseItem = zod.object({
  abacus_state_id: zod
    .number()
    .min(getAbacusStatesByParentTableResponseAbacusStateIdMin)
    .optional()
    .describe("Abacus state ID"),
  action_name: zod
    .enum([
      "payment_eligibility",
      "tax_eligibility",
      "approve_sales_files",
      "close_period",
      "deliver_sales_files",
      "mark_runs_as_complete",
      "prep_mechanical_deductions",
      "commit_royalties",
      "legacy_sync",
      "sap_sync",
      "banking_details_review",
      "payment_eligibility",
      "banking_eligibility",
      "generate_export",
      "generate_payments",
      "send_payments",
      "upload_approval",
      "send_payments",
      "calculate_payments",
      "generate_export",
      "generate_payments",
      "send_payments",
      "upload_approval",
      "send_payment",
      "approve_sales",
      "get_eligible_sales",
      "release_reserves",
      "statement_period_close",
      "upload_exchange_rates",
      "apply_file",
      "approve_file",
      "import_file",
      "upload_file",
      "close_balance",
      "collaborators_auto_report_run",
      "funds_confirmed",
      "salesforce_id_confirmed",
      "salesforce_id_linked",
      "send_payments",
    ])
    .optional()
    .describe("Abacus state action name"),
  action_status: zod
    .enum(["approved", "complete", "error", "init", "rejected", "running"])
    .optional()
    .describe("Abacus state action status"),
  created_at: zod
    .string()
    .datetime({})
    .optional()
    .describe("A datetime string formatted as YYYY-MM-DDTHH:MM:SS.fz"),
  created_by: zod.string().optional(),
  last_modified: zod
    .string()
    .datetime({})
    .optional()
    .describe("A datetime string formatted as YYYY-MM-DDTHH:MM:SS.fz"),
  last_modified_by: zod.string().optional(),
  message: zod
    .string()
    .nullish()
    .describe("A description or message about the state"),
  parent_table_id: zod
    .number()
    .min(getAbacusStatesByParentTableResponseParentTableIdMin)
    .optional()
    .describe("ID in the parent table"),
  parent_table_name: zod
    .enum([
      "account_payee",
      "accounting_period",
      "accounting_run",
      "contract",
      "payee",
      "payment_group_payment",
      "payment_group_payment_account",
      "payment_group_payment_batch",
      "sales_file",
      "statement_period",
      "statement_period_adjustment_file",
      "statement_period_payment_entity",
      "worksheet_payment_contract_advance",
    ])
    .optional()
    .describe("Name of the parent table"),
});
export const getAbacusStatesByParentTableResponse = zod.array(
  getAbacusStatesByParentTableResponseItem,
);

/**
 * Dataload Abacus states by Abacus state IDs
 */
export const dataloadAbacusStatesHeader = zod.object({
  "Correlation-Id": zod.string().optional().describe("Correlation ID"),
});

export const dataloadAbacusStatesBodyMin = 0;

export const dataloadAbacusStatesBodyItem = zod
  .number()
  .min(dataloadAbacusStatesBodyMin)
  .describe("Abacus state ID");
export const dataloadAbacusStatesBody = zod.array(dataloadAbacusStatesBodyItem);

export const dataloadAbacusStatesResponseItemsItemDataAbacusStateIdMin = 0;
export const dataloadAbacusStatesResponseItemsItemDataParentTableIdMin = 0;

export const dataloadAbacusStatesResponse = zod
  .object({
    items: zod
      .array(
        zod
          .object({
            data: zod.object({
              abacus_state_id: zod
                .number()
                .min(dataloadAbacusStatesResponseItemsItemDataAbacusStateIdMin)
                .optional()
                .describe("Abacus state ID"),
              action_name: zod
                .enum([
                  "payment_eligibility",
                  "tax_eligibility",
                  "approve_sales_files",
                  "close_period",
                  "deliver_sales_files",
                  "mark_runs_as_complete",
                  "prep_mechanical_deductions",
                  "commit_royalties",
                  "legacy_sync",
                  "sap_sync",
                  "banking_details_review",
                  "payment_eligibility",
                  "banking_eligibility",
                  "generate_export",
                  "generate_payments",
                  "send_payments",
                  "upload_approval",
                  "send_payments",
                  "calculate_payments",
                  "generate_export",
                  "generate_payments",
                  "send_payments",
                  "upload_approval",
                  "send_payment",
                  "approve_sales",
                  "get_eligible_sales",
                  "release_reserves",
                  "statement_period_close",
                  "upload_exchange_rates",
                  "apply_file",
                  "approve_file",
                  "import_file",
                  "upload_file",
                  "close_balance",
                  "collaborators_auto_report_run",
                  "funds_confirmed",
                  "salesforce_id_confirmed",
                  "salesforce_id_linked",
                  "send_payments",
                ])
                .optional()
                .describe("Abacus state action name"),
              action_status: zod
                .enum([
                  "approved",
                  "complete",
                  "error",
                  "init",
                  "rejected",
                  "running",
                ])
                .optional()
                .describe("Abacus state action status"),
              created_at: zod
                .string()
                .datetime({})
                .optional()
                .describe(
                  "A datetime string formatted as YYYY-MM-DDTHH:MM:SS.fz",
                ),
              created_by: zod.string().optional(),
              last_modified: zod
                .string()
                .datetime({})
                .optional()
                .describe(
                  "A datetime string formatted as YYYY-MM-DDTHH:MM:SS.fz",
                ),
              last_modified_by: zod.string().optional(),
              message: zod
                .string()
                .nullish()
                .describe("A description or message about the state"),
              parent_table_id: zod
                .number()
                .min(dataloadAbacusStatesResponseItemsItemDataParentTableIdMin)
                .optional()
                .describe("ID in the parent table"),
              parent_table_name: zod
                .enum([
                  "account_payee",
                  "accounting_period",
                  "accounting_run",
                  "contract",
                  "payee",
                  "payment_group_payment",
                  "payment_group_payment_account",
                  "payment_group_payment_batch",
                  "sales_file",
                  "statement_period",
                  "statement_period_adjustment_file",
                  "statement_period_payment_entity",
                  "worksheet_payment_contract_advance",
                ])
                .optional()
                .describe("Name of the parent table"),
            }),
          })
          .describe("{data: AbacusState }"),
      )
      .describe("[ {data: AbacusState } ]"),
  })
  .describe("{ items: [ {data: AbacusState } ] }");

/**
 * Create abacus states
 */
export const createAbacusStatesHeader = zod.object({
  "Correlation-Id": zod.string().optional().describe("Correlation ID"),
});

export const createAbacusStatesBodyParentTableIdMin = 0;

export const createAbacusStatesBodyItem = zod.object({
  action_name: zod
    .enum([
      "payment_eligibility",
      "tax_eligibility",
      "approve_sales_files",
      "close_period",
      "deliver_sales_files",
      "mark_runs_as_complete",
      "prep_mechanical_deductions",
      "commit_royalties",
      "legacy_sync",
      "sap_sync",
      "banking_details_review",
      "payment_eligibility",
      "banking_eligibility",
      "generate_export",
      "generate_payments",
      "send_payments",
      "upload_approval",
      "send_payments",
      "calculate_payments",
      "generate_export",
      "generate_payments",
      "send_payments",
      "upload_approval",
      "send_payment",
      "approve_sales",
      "get_eligible_sales",
      "release_reserves",
      "statement_period_close",
      "upload_exchange_rates",
      "apply_file",
      "approve_file",
      "import_file",
      "upload_file",
      "close_balance",
      "collaborators_auto_report_run",
      "funds_confirmed",
      "salesforce_id_confirmed",
      "salesforce_id_linked",
      "send_payments",
    ])
    .describe("Abacus state action name"),
  parent_table_id: zod
    .number()
    .min(createAbacusStatesBodyParentTableIdMin)
    .describe("ID in the parent table"),
  parent_table_name: zod
    .enum([
      "account_payee",
      "accounting_period",
      "accounting_run",
      "contract",
      "payee",
      "payment_group_payment",
      "payment_group_payment_account",
      "payment_group_payment_batch",
      "sales_file",
      "statement_period",
      "statement_period_adjustment_file",
      "statement_period_payment_entity",
      "worksheet_payment_contract_advance",
    ])
    .describe("Name of the parent table"),
});
export const createAbacusStatesBody = zod.array(createAbacusStatesBodyItem);

/**
 * Update action status of abacus states
 */
export const updateAbacusStatesParams = zod.object({
  parent_table_name: zod
    .enum([
      "account_payee",
      "accounting_period",
      "accounting_run",
      "contract",
      "payee",
      "payment_group_payment",
      "payment_group_payment_account",
      "payment_group_payment_batch",
      "sales_file",
      "statement_period",
      "statement_period_adjustment_file",
      "statement_period_payment_entity",
      "worksheet_payment_contract_advance",
    ])
    .describe("Name of the royalty_accounting table"),
});

export const updateAbacusStatesHeader = zod.object({
  "Correlation-Id": zod.string().optional().describe("Correlation ID"),
});

export const updateAbacusStatesBodyAbacusStateIdMin = 0;
export const updateAbacusStatesBodyParentTableIdMin = 0;

export const updateAbacusStatesBodyItem = zod.object({
  abacus_state_id: zod
    .number()
    .min(updateAbacusStatesBodyAbacusStateIdMin)
    .optional()
    .describe("Abacus state ID"),
  action_name: zod
    .enum([
      "payment_eligibility",
      "tax_eligibility",
      "approve_sales_files",
      "close_period",
      "deliver_sales_files",
      "mark_runs_as_complete",
      "prep_mechanical_deductions",
      "commit_royalties",
      "legacy_sync",
      "sap_sync",
      "banking_details_review",
      "payment_eligibility",
      "banking_eligibility",
      "generate_export",
      "generate_payments",
      "send_payments",
      "upload_approval",
      "send_payments",
      "calculate_payments",
      "generate_export",
      "generate_payments",
      "send_payments",
      "upload_approval",
      "send_payment",
      "approve_sales",
      "get_eligible_sales",
      "release_reserves",
      "statement_period_close",
      "upload_exchange_rates",
      "apply_file",
      "approve_file",
      "import_file",
      "upload_file",
      "close_balance",
      "collaborators_auto_report_run",
      "funds_confirmed",
      "salesforce_id_confirmed",
      "salesforce_id_linked",
      "send_payments",
    ])
    .optional()
    .describe("Abacus state action name"),
  action_status: zod
    .enum(["approved", "complete", "error", "init", "rejected", "running"])
    .optional()
    .describe("Abacus state action status"),
  created_at: zod
    .string()
    .datetime({})
    .optional()
    .describe("A datetime string formatted as YYYY-MM-DDTHH:MM:SS.fz"),
  created_by: zod.string().optional(),
  last_modified: zod
    .string()
    .datetime({})
    .optional()
    .describe("A datetime string formatted as YYYY-MM-DDTHH:MM:SS.fz"),
  last_modified_by: zod.string().optional(),
  message: zod
    .string()
    .nullish()
    .describe("A description or message about the state"),
  parent_table_id: zod
    .number()
    .min(updateAbacusStatesBodyParentTableIdMin)
    .optional()
    .describe("ID in the parent table"),
  parent_table_name: zod
    .enum([
      "account_payee",
      "accounting_period",
      "accounting_run",
      "contract",
      "payee",
      "payment_group_payment",
      "payment_group_payment_account",
      "payment_group_payment_batch",
      "sales_file",
      "statement_period",
      "statement_period_adjustment_file",
      "statement_period_payment_entity",
      "worksheet_payment_contract_advance",
    ])
    .optional()
    .describe("Name of the parent table"),
});
export const updateAbacusStatesBody = zod.array(updateAbacusStatesBodyItem);

export const updateAbacusStatesResponseAbacusStateIdMin = 0;
export const updateAbacusStatesResponseParentTableIdMin = 0;

export const updateAbacusStatesResponseItem = zod.object({
  abacus_state_id: zod
    .number()
    .min(updateAbacusStatesResponseAbacusStateIdMin)
    .optional()
    .describe("Abacus state ID"),
  action_name: zod
    .enum([
      "payment_eligibility",
      "tax_eligibility",
      "approve_sales_files",
      "close_period",
      "deliver_sales_files",
      "mark_runs_as_complete",
      "prep_mechanical_deductions",
      "commit_royalties",
      "legacy_sync",
      "sap_sync",
      "banking_details_review",
      "payment_eligibility",
      "banking_eligibility",
      "generate_export",
      "generate_payments",
      "send_payments",
      "upload_approval",
      "send_payments",
      "calculate_payments",
      "generate_export",
      "generate_payments",
      "send_payments",
      "upload_approval",
      "send_payment",
      "approve_sales",
      "get_eligible_sales",
      "release_reserves",
      "statement_period_close",
      "upload_exchange_rates",
      "apply_file",
      "approve_file",
      "import_file",
      "upload_file",
      "close_balance",
      "collaborators_auto_report_run",
      "funds_confirmed",
      "salesforce_id_confirmed",
      "salesforce_id_linked",
      "send_payments",
    ])
    .optional()
    .describe("Abacus state action name"),
  action_status: zod
    .enum(["approved", "complete", "error", "init", "rejected", "running"])
    .optional()
    .describe("Abacus state action status"),
  created_at: zod
    .string()
    .datetime({})
    .optional()
    .describe("A datetime string formatted as YYYY-MM-DDTHH:MM:SS.fz"),
  created_by: zod.string().optional(),
  last_modified: zod
    .string()
    .datetime({})
    .optional()
    .describe("A datetime string formatted as YYYY-MM-DDTHH:MM:SS.fz"),
  last_modified_by: zod.string().optional(),
  message: zod
    .string()
    .nullish()
    .describe("A description or message about the state"),
  parent_table_id: zod
    .number()
    .min(updateAbacusStatesResponseParentTableIdMin)
    .optional()
    .describe("ID in the parent table"),
  parent_table_name: zod
    .enum([
      "account_payee",
      "accounting_period",
      "accounting_run",
      "contract",
      "payee",
      "payment_group_payment",
      "payment_group_payment_account",
      "payment_group_payment_batch",
      "sales_file",
      "statement_period",
      "statement_period_adjustment_file",
      "statement_period_payment_entity",
      "worksheet_payment_contract_advance",
    ])
    .optional()
    .describe("Name of the parent table"),
});
export const updateAbacusStatesResponse = zod.array(
  updateAbacusStatesResponseItem,
);

/**
 * Create Abacus state records for the specified parent table ID
 */
export const createAbacusStatesByParentTablePathParentTableIdMin = 0;

export const createAbacusStatesByParentTableParams = zod.object({
  parent_table_id: zod
    .number()
    .min(createAbacusStatesByParentTablePathParentTableIdMin)
    .describe("The ID of the record in the parent table"),
  parent_table_name: zod
    .enum([
      "account_payee",
      "accounting_period",
      "accounting_run",
      "contract",
      "payee",
      "payment_group_payment",
      "payment_group_payment_account",
      "payment_group_payment_batch",
      "sales_file",
      "statement_period",
      "statement_period_adjustment_file",
      "statement_period_payment_entity",
      "worksheet_payment_contract_advance",
    ])
    .describe("Name of the royalty_accounting table"),
});

export const createAbacusStatesByParentTableQueryParams = zod.object({
  contract_type: zod
    .enum(["distribution", "neighbouring_rights"])
    .optional()
    .describe("The contract type"),
});

export const createAbacusStatesByParentTableHeader = zod.object({
  "Correlation-Id": zod.string().optional().describe("Correlation ID"),
});

/**
 * Check the health of the application.
 */
export const getHealthHeader = zod.object({
  "Correlation-Id": zod.string().optional().describe("Correlation ID"),
});

export const getHealthResponse = zod.object({
  status: zod.enum(["ok"]),
});
/**
 * Generated by @abacus/api-client-generator
 * Do not edit manually.
 */
const z = zod;

const AbacusStateId = z.number();
const AbacusStateActionName = z.enum([
  "payment_eligibility",
  "tax_eligibility",
  "approve_sales_files",
  "close_period",
  "deliver_sales_files",
  "mark_runs_as_complete",
  "prep_mechanical_deductions",
  "commit_royalties",
  "legacy_sync",
  "sap_sync",
  "banking_details_review",
  "payment_eligibility",
  "banking_eligibility",
  "generate_export",
  "generate_payments",
  "send_payments",
  "upload_approval",
  "send_payments",
  "calculate_payments",
  "generate_export",
  "generate_payments",
  "send_payments",
  "upload_approval",
  "send_payment",
  "approve_sales",
  "get_eligible_sales",
  "release_reserves",
  "statement_period_close",
  "upload_exchange_rates",
  "apply_file",
  "approve_file",
  "import_file",
  "upload_file",
  "close_balance",
  "collaborators_auto_report_run",
  "funds_confirmed",
  "salesforce_id_confirmed",
  "salesforce_id_linked",
  "send_payments",
]);
const AbacusStateActionStatus = z.enum([
  "approved",
  "complete",
  "error",
  "init",
  "rejected",
  "running",
]);
const DateTime = z.string();
const AbacusStateMessage = z.string();
const ParentTableId = z.number();
const ParentTableName = z.enum([
  "account_payee",
  "accounting_period",
  "accounting_run",
  "contract",
  "payee",
  "payment_group_payment",
  "payment_group_payment_account",
  "payment_group_payment_batch",
  "sales_file",
  "statement_period",
  "statement_period_adjustment_file",
  "statement_period_payment_entity",
  "worksheet_payment_contract_advance",
]);
const PartialAbacusState = z
  .object({
    abacus_state_id: AbacusStateId.int()
      .gte(0)
      .describe("The ID of the Abacus state"),
    action_name: AbacusStateActionName.describe("Abacus state action name"),
    action_status: AbacusStateActionStatus.describe(
      "Abacus state action status",
    ),
    created_at: DateTime.datetime({ offset: true }).describe(
      "A datetime string formatted as YYYY-MM-DDTHH:MM:SS.fz",
    ),
    created_by: z.string(),
    last_modified: DateTime.datetime({ offset: true }).describe(
      "A datetime string formatted as YYYY-MM-DDTHH:MM:SS.fz",
    ),
    last_modified_by: z.string(),
    message: AbacusStateMessage.describe(
      "A description or message about the state",
    ).nullable(),
    parent_table_id: ParentTableId.int()
      .gte(0)
      .describe("ID in the parent table"),
    parent_table_name: ParentTableName.describe("Name of the parent table"),
  })
  .partial()
  .passthrough();
const AbacusState = PartialAbacusState;
const Health = z.object({ status: z.literal("ok") }).passthrough();
const ContractType = z.enum(["distribution", "neighbouring_rights"]);

export const abacusStateId = AbacusStateId;
export const abacusStateActionName = AbacusStateActionName;
export const abacusStateActionStatus = AbacusStateActionStatus;
export const dateTime = DateTime;
export const abacusStateMessage = AbacusStateMessage;
export const parentTableId = ParentTableId;
export const parentTableName = ParentTableName;
export const partialAbacusState = PartialAbacusState;
export const abacusState = AbacusState;
export const health = Health;
export const contractType = ContractType;
